import { ReactNode } from 'react';
import { LockIcon } from '@wisdesign/lsicon';

interface NoPermissionPageProps {
  /** 标题 */
  title?: string;
  /** 描述 */
  description?: string;
  /** 自定义图标 */
  icon?: ReactNode;
  /** 额外内容 */
  children?: ReactNode;
  /** 自定义样式类 */
  className?: string;
}

/**
 * 无权限页面组件
 * 用于显示没有权限时的居中提示
 */
export const NoPermissionPage = ({
  title = '没有权限',
  description = '您没有访问此页面的权限',
  icon = <LockIcon className="w-16 h-16 text-gray-400" />,
  children,
  className = '',
}: NoPermissionPageProps) => {
  return (
    <div className={`flex items-center justify-center min-h-[400px] ${className}`}>
      <div className="text-center">
        <div className="mb-4 flex justify-center">{icon}</div>
        <h2 className="text-xl font-medium text-gray-900 mb-2">{title}</h2>
        <p className="text-gray-500 mb-6">{description}</p>
        {children}
      </div>
    </div>
  );
};
